var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7863 14.4511C16.7716 14.4511 18.4908 13.739 19.8954 12.3342C21.3 10.9295 22.0121 9.21086 22.0121 7.22531C22.0121 5.24046 21.3 3.52156 19.8952 2.11646C18.4903 0.712049 16.7714 0 14.7863 0C12.8008 0 11.0821 0.712049 9.67747 2.11669C8.27282 3.52133 7.56055 5.24023 7.56055 7.22531C7.56055 9.21086 8.27282 10.9298 9.6777 12.3344C11.0826 13.7388 12.8015 14.4511 14.7863 14.4511Z",
    fill: "#396AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4293 23.0684C27.3888 22.4838 27.3069 21.8462 27.1863 21.1728C27.0645 20.4944 26.9077 19.8531 26.72 19.2669C26.5262 18.6611 26.2625 18.0628 25.9366 17.4894C25.5983 16.8943 25.2009 16.3762 24.7551 15.9497C24.2889 15.5037 23.718 15.145 23.0579 14.8834C22.4001 14.6232 21.6711 14.4913 20.8913 14.4913C20.5851 14.4913 20.2889 14.617 19.717 14.9894C19.3649 15.2189 18.9532 15.4844 18.4936 15.7781C18.1006 16.0285 17.5682 16.2631 16.9106 16.4755C16.2691 16.6831 15.6177 16.7884 14.9748 16.7884C14.3318 16.7884 13.6807 16.6831 13.0384 16.4755C12.3816 16.2633 11.8492 16.0287 11.4566 15.7783C11.0014 15.4874 10.5894 15.2219 10.2321 14.9891C9.66084 14.6167 9.36444 14.4911 9.0582 14.4911C8.27818 14.4911 7.54942 14.6232 6.89184 14.8836C6.23221 15.1448 5.66115 15.5034 5.19446 15.95C4.74883 16.3766 4.35127 16.8946 4.01344 17.4894C3.68774 18.0628 3.42407 18.6608 3.22998 19.2671C3.04252 19.8533 2.88574 20.4944 2.76398 21.1728C2.64336 21.8453 2.56142 22.4832 2.5209 23.0691C2.48108 23.6431 2.46094 24.2389 2.46094 24.8406C2.46094 26.4066 2.95875 27.6744 3.94042 28.6094C4.90996 29.532 6.19284 30.0001 7.75289 30.0001H22.198C23.7581 30.0001 25.0405 29.5322 26.0103 28.6094C26.9922 27.6751 27.49 26.4071 27.49 24.8404C27.4898 24.2359 27.4694 23.6397 27.4293 23.0684Z",
    fill: "#396AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9999,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.ca14abe8e6aa90cb81fc0e0af4bc3f92.svg";
export { ForwardRef as ReactComponent };